import { Pipe, PipeTransform } from '@angular/core';
import { DateFormatService } from '@flyfreely-portal-ui/flyfreely';
import moment from 'moment';
@Pipe({
    name: 'formatDateRange'
})
export class FormatDateRangePipe implements PipeTransform {
    constructor(private dateFormatService: DateFormatService) {}
    transform(
        startTime: string,
        endTime: string | null,
        timeZone: string
    ): unknown {
        if (!startTime) {
            return '';
        }

        const dateFormat = this.dateFormatService.getDateFormat();
        const timeFormat = this.dateFormatService.getTimeFormat();
        const dateTimeFormat = this.dateFormatService.getDateTimeFormat();

        const startMoment = moment(startTime).tz(timeZone);
        const endMoment = endTime ? moment(endTime).tz(timeZone) : null;

        if (!endMoment) {
            return `${startMoment.format(
                dateTimeFormat
            )} - PERM ${startMoment.format('z')}`;
        }

        const startDay = startMoment.format(dateFormat);
        const endDay = endMoment.format(dateFormat);

        if (startDay === endDay) {
            return `${startDay} ${startMoment.format(
                timeFormat
            )} - ${endMoment.format(timeFormat)} ${endMoment.format('z')}`;
        }

        return `${startMoment.format(dateTimeFormat)} - ${endMoment.format(
            dateTimeFormat
        )} ${endMoment.format('z')}`;
    }
}
